import React, { useState } from "react";
import {
  FaTimes,
  FaPaperclip,
  FaUserNurse,
  FaTrash,
  FaFilePdf,
  FaFileImage,
  FaFileAlt,
} from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { message } from "antd";
import dayjs from "dayjs";
import ClinicalNotesService from "../../../../Services/ClinicalNotesService";

function AddNurseActionNoteModal({
  onClose,
  onSuccess,
  patientDetails,
  patientId,
  admissionId,
}) {
  const loginObj =
    sessionStorage.getItem("login_result") ||
    localStorage.getItem("login_result");
  const userData = loginObj ? JSON.parse(loginObj) : null;
  const activePatient = JSON.parse(
    sessionStorage.getItem("patient") || "null"
  );

  const effectivePatientId =
    patientId || patientDetails?.patientId || activePatient?.patientId || "";
  const effectiveAdmissionNo =
    patientDetails?.admissionNo ||
    activePatient?.admissionNo ||
    admissionId ||
    "";
  const effectiveEncounterId =
    patientDetails?.encounterId ||
    patientDetails?.admissionId ||
    activePatient?.admissionId ||
    admissionId ||
    0;

  const currentUserId = userData?.user?.userId || "DZU7321276";
  const currentUserName =
    userData?.user?.userName ||
    userData?.user?.firstName ||
    "Dr. Hari Prakash";

  const NURSE_OPTIONS = [
    { id: "DZU7321300", name: "Nurse Kavitha R" },
    { id: "DZU7321301", name: "Nurse Priya M" },
    { id: "DZU7321302", name: "Nurse John D" },
    { id: "DZU2991191", name: "Ms. Divya Sri" },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const [formData, setFormData] = useState({
    noteTypeId: 0,
    noteDatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    noteText: "",
    nurseActionRequired: "Y",
    nurseActionInstructions: "",
    assignedNurseId: "DZU7321300",
    assignedNurseName: "Nurse Kavitha R",
    priority: "HIGH",
    dueDatetime: dayjs().add(4, "hour").format("YYYY-MM-DD HH:mm:ss"),
    status: "OPEN",
    recordedBy: currentUserId,
    recordedByName: currentUserName,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNurseChange = (nurseId) => {
    const selected = NURSE_OPTIONS.find((n) => n.id === nurseId);
    setFormData((prev) => ({
      ...prev,
      assignedNurseId: nurseId,
      assignedNurseName: selected?.name || "",
    }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    files.forEach((file) => {
      if (file.size > 10 * 1024 * 1024) {
        message.warning(`${file.name} exceeds 10MB limit.`);
        return;
      }

      const reader = new FileReader();
      reader.onload = (uploadEvent) => {
        const fullDataUrl = uploadEvent.target.result;
        // Strip data:image/...;base64, or data:application/...;base64, prefix if present
        const base64Pure = fullDataUrl.includes(",")
          ? fullDataUrl.split(",")[1]
          : fullDataUrl;
        const extension = file.name.split(".").pop().toLowerCase();

        const newAttachment = {
          fileName: file.name,
          fileSizeKb: Math.round(file.size / 1024),
          entityType: "CLINICAL_NOTE",
          image: base64Pure,
          fileType: extension || "jpeg",
          isDeleted: "N",
        };

        setAttachments((prev) => [...prev, newAttachment]);
      };
      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const handleRemoveAttachment = (indexToRemove) => {
    setAttachments((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();

    if (!formData.noteText || !formData.noteText.trim()) {
      message.warning("Please enter note content before saving.");
      return;
    }

    if (
      formData.nurseActionRequired === "Y" &&
      (!formData.nurseActionInstructions ||
        !formData.nurseActionInstructions.trim())
    ) {
      message.warning("Please provide nurse action instructions.");
      return;
    }

    setIsLoading(true);
    const currentFormattedDate = dayjs().format("YYYY-MM-DD HH:mm:ss");

    const payload = {
      admissionNo: String(effectiveAdmissionNo),
      assignedNurseId:
        formData.nurseActionRequired === "Y"
          ? formData.assignedNurseId || "DZU7321300"
          : undefined,
      assignedNurseName:
        formData.nurseActionRequired === "Y"
          ? formData.assignedNurseName || "Nurse Kavitha R"
          : undefined,
      attachments: attachments.map((att) => ({
        entityType: "CLINICAL_NOTE",
        fileSizeKb: att.fileSizeKb,
        fileType: att.fileType,
        image: att.image,
        isDeleted: "N",
      })),
      createdBy: currentUserId,
      createdDatetime: currentFormattedDate,
      dueDatetime:
        formData.nurseActionRequired === "Y"
          ? formData.dueDatetime || currentFormattedDate
          : undefined,
      encounterId: Number(effectiveEncounterId) || 0,
      isDeleted: "N",
      noteDatetime: formData.noteDatetime || currentFormattedDate,
      noteText: formData.noteText.trim(),
      noteTypeId: Number(formData.noteTypeId) || 0,
      nurseActionInstructions:
        formData.nurseActionRequired === "Y"
          ? formData.nurseActionInstructions.trim()
          : "",
      nurseActionRequired: formData.nurseActionRequired || "Y",
      patientId: String(effectivePatientId),
      priority: formData.priority || "HIGH",
      recordedBy: formData.recordedBy || currentUserId,
      recordedByName: formData.recordedByName || currentUserName,
      status: formData.status || "OPEN",
      updatedBy: currentUserId,
      updatedDatetime: currentFormattedDate,
    };

    console.log("Saving Nurse Action Note Payload:", payload);

    try {
      await ClinicalNotesService.saveClinicalNote(payload);
      message.success("Nurse action note saved successfully.");
      if (onSuccess) {
        onSuccess();
      }
      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error("Error saving nurse action note:", error);
      message.error(
        error?.response?.data?.message ||
          "Failed to save nurse action note. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getFileIcon = (type) => {
    if (type === "pdf") return <FaFilePdf className="text-red-500 text-sm" />;
    if (["jpg", "jpeg", "png", "webp"].includes(type))
      return <FaFileImage className="text-blue-500 text-sm" />;
    return <FaFileAlt className="text-gray-500 text-sm" />;
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl bg-white rounded-[22px] overflow-hidden shadow-2xl max-h-[92vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="px-6 py-4 flex items-center justify-between border-b border-[#edf1f7] bg-[#fcfdfe]">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-teal-50 flex items-center justify-center text-[#008f9f]">
              <FaUserNurse className="text-lg" />
            </div>
           
          </div>
          <button
            onClick={onClose}
            className="text-[#6b7280] bg-white hover:text-[#111827] p-1.5 rounded-lg hover:bg-gray-100 transition"
          >
            <FaTimes className="text-[15px]" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto space-y-5 custom-scrollbar">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                Note Type
              </label>
              <div className="relative">
                <select
                  value={formData.noteTypeId}
                  onChange={(e) =>
                    handleInputChange("noteTypeId", Number(e.target.value))
                  }
                  className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none appearance-none focus:border-[#008f9f] bg-white"
                >
                  <option value={0}>Doctor Note (Clinical)</option>
                  <option value={2}>Nurse Action Note</option>
                </select>
                <FiChevronDown className="absolute right-3 top-3.5 text-[#6b7280] pointer-events-none" />
              </div>
            </div>

            <div>
              <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                Note Date & Time
              </label>
              <input
                type="datetime-local"
                value={dayjs(formData.noteDatetime).format("YYYY-MM-DDTHH:mm")}
                onChange={(e) => {
                  const val = e.target.value
                    ? dayjs(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                    : dayjs().format("YYYY-MM-DD HH:mm:ss");
                  handleInputChange("noteDatetime", val);
                }}
                className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none focus:border-[#008f9f] bg-white"
              />
            </div>
          </div>

          {/* Row 2: Recorded By & Priority */}
          <div className="grid grid-cols-2 gap-4">
           

            <div>
              <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                Priority
              </label>
              <div className="relative">
                <select
                  value={formData.priority}
                  onChange={(e) =>
                    handleInputChange("priority", e.target.value)
                  }
                  className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none appearance-none focus:border-[#008f9f] bg-white font-semibold text-[#b91c1c]"
                >
                  <option value="URGENT">URGENT</option>
                  <option value="HIGH">HIGH</option>
                  <option value="MEDIUM">MEDIUM</option>
                  <option value="ROUTINE">ROUTINE</option>
                  <option value="LOW">LOW</option>
                </select>
                <FiChevronDown className="absolute right-3 top-3.5 text-[#6b7280] pointer-events-none" />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
              Doctor Note / Clinical Observations
              <span className="text-red-500">*</span>
            </label>
            <textarea
              rows="3"
              value={formData.noteText}
              onChange={(e) => handleInputChange("noteText", e.target.value)}
              className="w-full p-3.5 text-[13px] text-[#111827] border border-[#edf1f7] rounded-xl outline-none resize-none focus:border-[#008f9f] focus:ring-1 focus:ring-[#008f9f]"
            />
          </div>

          <div className="border border-teal-200/80 rounded-2xl p-4 bg-[#f4fbfa] space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="nurseActionReqCheck"
                  checked={formData.nurseActionRequired === "Y"}
                  onChange={(e) =>
                    handleInputChange(
                      "nurseActionRequired",
                      e.target.checked ? "Y" : "N"
                    )
                  }
                  className="w-4 h-4 rounded text-[#008f9f] focus:ring-[#008f9f] border-gray-300 cursor-pointer"
                />
                <label
                  htmlFor="nurseActionReqCheck"
                  className="text-[13px] font-bold text-[#0f766e] cursor-pointer"
                >
                  Nurse Action Required
                </label>
              </div>

             
            </div>

            {formData.nurseActionRequired === "Y" && (
              <div className="space-y-4 pt-1">
                <div>
                  <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                    Nurse Action Instructions{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    rows="3"
                    value={formData.nurseActionInstructions}
                    onChange={(e) =>
                      handleInputChange(
                        "nurseActionInstructions",
                        e.target.value
                      )
                    }
                    className="w-full p-3 text-[13px] text-[#111827] border border-[#d1fae5] bg-white rounded-xl outline-none resize-none focus:border-[#008f9f]"
                  />
                </div>

                <div className="grid grid-cols-3 gap-3">
                  {/* <div>
                    <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                      Assigned Nurse
                    </label>
                    <div className="relative">
                      <select
                        value={formData.assignedNurseId}
                        onChange={(e) => handleNurseChange(e.target.value)}
                        className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none appearance-none focus:border-[#008f9f] bg-white"
                      >
                        {NURSE_OPTIONS.map((nurse) => (
                          <option key={nurse.id} value={nurse.id}>
                            {nurse.name} ({nurse.id})
                          </option>
                        ))}
                      </select>
                      <FiChevronDown className="absolute right-3 top-3.5 text-[#6b7280] pointer-events-none" />
                    </div>
                  </div> */}

                  <div>
                    <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                      Due Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      value={dayjs(formData.dueDatetime).format(
                        "YYYY-MM-DDTHH:mm"
                      )}
                      onChange={(e) => {
                        const val = e.target.value
                          ? dayjs(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                          : dayjs().format("YYYY-MM-DD HH:mm:ss");
                        handleInputChange("dueDatetime", val);
                      }}
                      className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none focus:border-[#008f9f] bg-white"
                    />
                  </div>

                  <div>
                    <label className="block text-[12px] font-semibold text-[#374151] mb-1.5">
                      Task Status
                    </label>
                    <div className="relative">
                      <select
                        value={formData.status}
                        onChange={(e) =>
                          handleInputChange("status", e.target.value)
                        }
                        className="w-full h-10 px-3 border border-[#edf1f7] rounded-lg text-[13px] text-[#111827] outline-none appearance-none focus:border-[#008f9f] bg-white font-medium"
                      >
                        <option value="OPEN">OPEN</option>
                        <option value="IN_PROGRESS">IN_PROGRESS</option>
                        <option value="COMPLETED">COMPLETED</option>
                      </select>
                      <FiChevronDown className="absolute right-3 top-3.5 text-[#6b7280] pointer-events-none" />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Attachments Upload */}
          <div>
            <div className="flex items-center justify-between mb-1.5">
              <label className="text-[12px] font-semibold text-[#374151]">
                Attachments ({attachments.length})
              </label>
              <span className="text-[11px] text-[#9ca3af]">
                PDF, JPG, PNG up to 10MB
              </span>
            </div>

            <label className="border-2 border-dashed border-[#edf1f7] rounded-xl bg-[#fafbff] flex flex-col items-center justify-center py-4 cursor-pointer hover:bg-gray-50 transition-colors block">
              <input
                type="file"
                multiple
                accept=".pdf,.jpg,.jpeg,.png,.webp"
                className="hidden"
                onChange={handleFileUpload}
              />
              <div className="flex items-center gap-2 text-[#5b5bd6] text-[13px] font-semibold">
                <FaPaperclip />
                <span>Upload files / reports</span>
              </div>
            </label>

            {attachments.length > 0 && (
              <div className="mt-2.5 space-y-1.5">
                {attachments.map((file, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-2.5 rounded-lg border border-[#edf1f7] bg-white text-xs"
                  >
                    <div className="flex items-center gap-2 min-w-0">
                      {getFileIcon(file.fileType)}
                      <span className="font-semibold text-gray-800 truncate">
                        {file.fileName || `Attachment_${index + 1}.${file.fileType}`}
                      </span>
                      <span className="text-gray-400 text-[11px]">
                        ({file.fileSizeKb} KB)
                      </span>
                    </div>
                    <button
                      onClick={() => handleRemoveAttachment(index)}
                      className="text-gray-400 bg-white hover:text-red-500 p-1"
                    >
                      <FaTrash className="text-xs" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 border-t border-[#edf1f7] flex justify-end gap-3 bg-white">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-white rounded-lg border border-[#edf1f7] text-[#4b5563] text-[13px] font-bold hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            disabled={isLoading}
            onClick={handleSubmit}
            className="px-6 py-2 rounded-lg bg-[#008f9f] text-white text-[13px] font-bold hover:bg-[#007a8a] disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm"
          >
            {isLoading ? "Saving..." : "Save Nurse Action Note"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNurseActionNoteModal;
